import { useState, useEffect } from 'react';
import { FaCheck, FaTimes, FaBirthdayCake } from 'react-icons/fa';

export const AgeVerification = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const verified = localStorage.getItem('ageVerified');
    if (!verified) {
      setIsVisible(true);
    }
  }, []);

  const handleVerify = (isAdult: boolean) => {
    if (isAdult) {
      localStorage.setItem('ageVerified', 'true');
      setIsVisible(false);
    } else {
      window.location.href = 'https://www.gambleaware.org';
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 backdrop-blur-sm">
      <div className="bg-dark-800 border border-gray-700 rounded-2xl p-8 max-w-md mx-4 shadow-2xl animate-fade-in">
        <div className="text-center mb-6">
          <div className="w-20 h-20 mx-auto mb-4 bg-primary-500/20 rounded-full flex items-center justify-center">
            <FaBirthdayCake className="text-4xl text-red-500" />
          </div>
          <h2 className="text-2xl font-bold text-white mb-2">Age Verification Required</h2>
          <p className="text-gray-300">
            You must be 18 or older to access this website. Please confirm your age to continue.
          </p>
        </div>

        <div className="space-y-3">
          <button
            onClick={() => handleVerify(true)}
            className="w-full bg-gradient-to-r from-primary-500 to-accent-500 text-white font-semibold py-3 px-6 rounded-lg hover:from-primary-600 hover:to-accent-600 transition-all duration-200 flex items-center justify-center space-x-2 shadow-lg"
          >
            <FaCheck />
            <span>I am 18 or older</span>
          </button>
          <button
            onClick={() => handleVerify(false)}
            className="w-full bg-dark-700 text-gray-300 font-semibold py-3 px-6 rounded-lg hover:bg-dark-600 transition-colors flex items-center justify-center space-x-2 border border-gray-700"
          >
            <FaTimes />
            <span>I am under 18</span>
          </button>
        </div>

        <p className="text-xs text-gray-500 text-center mt-6">
          By continuing, you confirm that you are of legal gambling age in your jurisdiction.
        </p>
      </div>
    </div>
  );
};

